/**
 * @fileoverview CopyRights.jsx
 * 
 * © 2026 KITH Travels (Pvt) Ltd. All rights reserved.
 * This software is the confidential and proprietary information of KITH Travels.
 * You shall not disclose such Confidential Information and shall use it only in 
 * accordance with the terms of the license agreement you entered into with KITH Travels.
 */
import React from 'react'

function CopyRights() {
  return (
    <div className='w-full py-2 bg-KITH-primary-dark flex justify-center items-center'>
      <p className='text-xs md:text-sm text-white font-medium'>
        © {new Date().getFullYear()} KITH Travels (Pvt) Ltd. All rights reserved.
      </p>
    </div>
  )
}

export default CopyRights